/**
 * @file Social sharing.
 */

import { gsap } from 'gsap';

/**
 * Social sharing components.
 */
const vSocialSharing = () => {
	const socialShare = document.querySelector('.v-social-share');
	const socialCta = document.querySelector('.v-social-cta');

	if (!socialShare && !socialCta) {
		return;
	}

	const components = [socialShare, socialCta].filter(Boolean);
	components.forEach((component) => {
		const trigger = component.querySelector('.v-share-modal-trigger');
		const { url, title, text } = trigger.dataset;

		trigger.addEventListener('click', () => {
			if (navigator.share) {
				navigator
					.share({
						title,
						url,
						text,
					})
					.then(() => console.log('Successful share'))
					.catch((error) => console.log('Error sharing', error));
			} else {
				window.dispatchEvent(new CustomEvent('vOpenShareModal'));
			}
		});
	});

	const copyButtons = document.querySelectorAll('.v-social-copy');
	[...copyButtons].forEach((copyButton) => {
		const tooltip = copyButton.querySelector('.v-social-copy__tooltip');
		let { copy } = copyButton.dataset;
		const { type } = copyButton.dataset;
		if (type === 'url' && copy.indexOf(window.location.protocol) !== 0) {
			copy = `${window.location.protocol}${copy}`;
		}
		copyButton.addEventListener('click', () => {
			navigator.clipboard.writeText(copy).then(() => {
				gsap.to(tooltip, {
					overwrite: true,
					keyframes: [
						{ opacity: 1, y: 5, duration: 0.2 },
						{ opacity: 1, y: 8, duration: 0.6 },
						{ opacity: 0, y: 13, duration: 0.3 },
					],
					ease: 'sine.out',
					onComplete: () => {
						gsap.set(tooltip, { clearProps: 'all' });
					},
				});
			});
		});
	});
};

export default vSocialSharing;
